/**
 * Video nei blocchi (mosaic, imagescaption, wall, slidergallery) — sostituisce video.js.
 *
 * Markup: <video class="js-inline-video"> seguito, nello stesso contenitore,
 * da <a class="play-button">. Il pulsante avvia il video e mette in pausa gli
 * altri; click sul video = pausa; in pausa o a fine video torna il pulsante.
 */

export default function initInlineVideos(protectVideo) {
	const videos = Array.prototype.slice.call(document.querySelectorAll('.js-inline-video'));
	if (!videos.length) return;

	const showButton = (button, visible) => {
		if (button) button.style.display = visible ? 'flex' : 'none';
	};

	videos.forEach((video) => {
		const button = video.parentElement.querySelector('.play-button');
		video.controls = false;
		protectVideo(video);

		if (button) {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				videos.forEach((other) => {
					if (other !== video && !other.paused) other.pause();
				});
				showButton(button, false);
				// nei browser vecchi play() non restituisce una Promise
				const playing = video.play();
				if (playing && typeof playing.catch === 'function') {
					playing.catch(() => showButton(button, true));
				}
			});
		}

		video.addEventListener('click', () => {
			if (!video.paused) video.pause();
		});
		video.addEventListener('play', () => showButton(button, false));
		video.addEventListener('pause', () => showButton(button, true));
		video.addEventListener('ended', () => showButton(button, true));
	});
}
